
//IMPORTS
import React, { useEffect, useState, useRef} from 'react'
import { Modal } from 'react-bootstrap';
import { FormProvider, useForm } from 'react-hook-form';
import Button from '@mui/material/Button';
//COMPONENTS
import AgGridTable from 'src/components/AgGridTable'
import { CalendarFormRange } from 'src/components/ComponentesFormularios/CalendarForm';
import ExternalActionsTable from 'src/components/ExternalActionsTable';
import FilterTable from 'src/components/FilterTable';
import Tabs from 'src/components/Tabs';
import TransfertList from 'src/components/TransferList';
import Emitter from 'src/EventEmitter/EventEmitter';
//REDUX
import { useDispatch } from 'react-redux';
//STYLES
import { Colors } from 'src/assets/colors/Colors';
//UTILS
import { dateToStringFormat, getFechaToCalendarRange, validarFecha } from 'src/util/functions';
//CONSTANTS
import { GlobalConstants } from 'src/data/GlobalConstants';
import { classResponsiveFormDoubleWidthHeader, ERROREMAILFIELDREQUIRED } from 'src/data/ConstantForm';
//SERVICES
import { mercadoServices } from 'src/services/apiMercados';

const columns = [
  { headerName: 'Acciones', field: "acciones", cellRenderer: "accionesComponent", resizable: true, sortable: false, filter: false, maxWidth: 150 },
  { headerName: 'ID PRODUCTO', field: "nbProducto", resizable: true, sortable: true, filter: true, minWidth: 100 },
  { headerName: 'PRODUCTO', field: "nmProducto", resizable: true, sortable: true, filter: true, minWidth: 100 },
  { headerName: 'ORGANIZACION VENTAS', field: "nbOrgVentaSAP", resizable: true, sortable: true, filter: true, minWidth: 100, hide: true },
  { headerName: 'ID PROPIETARIO', field: "idPropietario", resizable: true, sortable: true, filter: true, minWidth: 100, hide: true },
  { headerName: 'PROPIETARIO', field: "propietario", resizable: true, sortable: true, filter: true, minWidth: 100 },
  { headerName: 'ID TIPO NEGOCIO', field: "nbTipoNegocio", resizable: true, sortable: true, filter: true, minWidth: 100, hide: true },
  { headerName: 'TIPO NEGOCIO', field: "nmTipoNegocio", resizable: true, sortable: true, filter: true, minWidth: 100 },
  { headerName: 'ID MARCA', field: "nbMarca", resizable: true, sortable: true, filter: true, minWidth: 100, hide: true},
  { headerName: 'MARCA', field: "nmMarca", resizable: true, sortable: true, filter: true, minWidth: 100 },
  { headerName: 'INICIO VIGENCIA', field: "dtVigenciaIni", resizable: true, sortable: true, filter: true, minWidth: 100, 
    editable: params => params.data.edit, 
    cellStyle: params => {
      if(params.data.edit){
        return {color: Colors.RED_SWITCH_INACTIVE, fontWeight: 'bold'}
      }
      return null;
    }},
  { headerName: 'FIN VIGENCIA', field: "dtVigenciaFin", resizable: true, sortable: true, filter: true, minWidth: 100, 
    editable: params => params.data.edit,
    cellStyle: params => {
      if(params.data.edit){
        return {color: Colors.RED_SWITCH_INACTIVE, fontWeight: 'bold'}
      }
      return null;
    }
  }
]

const Acciones = ({ params }) => {

  if(params.data.edit){
    return (
      <div className="d-flex justify-content-center align-items-center h-100">
        <i onClick={() => Emitter.emit('SAVE', {params, type: 'SAVE'})} style={{color: Colors.GREEN_SWITCH_ACTIVE, cursor: "pointer", fontSize: '18px'}} className="far fa-check mx-2"/>
        <i onClick={() => Emitter.emit('CANCEL', {params, type: 'CANCEL'})} style={{color: Colors.RED_SWITCH_INACTIVE, cursor: "pointer", fontSize: '18px'}} className="far fa-times mx-2"/>
      </div>
    )
  }

  return (
    <div className="d-flex justify-content-center align-items-center h-100">
      <i onClick={() => Emitter.emit('EDIT', {params, type: 'EDIT'})} style={{color: Colors.GREEN_SWITCH_ACTIVE, cursor: "pointer", fontSize: '18px'}} className="far fa-edit mx-2"/>
    </div>
  )

}

const Products = ({tableRef, rowData, producto}) => {

  const dispatch = useDispatch();

  const handleValueChange = (params) => {
    if(!validarFecha(params.newValue)){
      let data = params.data;
      data[params.colDef.field] = params.oldValue;
      params.api.applyTransaction({update: [data]});
      dispatch({ type: 'setStateAlert', alert: {type: GlobalConstants.alertWarning, message: 'La fecha ingresada no es válida'} })
    }    
  }

  const getStyle = (params) => {
    if(params.data.nbProducto === producto){
      return {
        backgroundColor: Colors.COLOR_CELL_BLUE,
        fontWeight: 'bold'
      }
    }

    return null;
  }

  return (
    <>
      <div className='d-flex align-items-center justify-content-between mx-1'>
        <FilterTable tableRef={tableRef} identificador="search" className="w-25"/>

        <ExternalActionsTable 
          accionVisibilidadColumnas={tableRef}
        />
      </div>
      <AgGridTable
        referencia={tableRef}
        columnDef={columns}
        dataList={rowData || []}
        acciones={Acciones}
        onCellValueChanged={handleValueChange}
        getRowStyle={getStyle}
      /> 
    </>
  )
}

const AddProducts = React.memo(({productos, productosSeleccionados, handleSave, onChange}) => {

  const [visible, setVisible] = useState(false);

  return (
    <div>
      <div className='d-flex justify-content-end mb-5 mt-2'>

        <button 
          className='btn text-center px-3 py-2 align-self-center'
          style={{backgroundColor: Colors.GREEN_SWITCH_ACTIVE, borderColor: Colors.GREEN_SWITCH_ACTIVE, color: 'white'}	}
          onClick={() => setVisible(true)}
          >
          <i className='fas fa-check mx-2'/> {` Agregar Productos`}
        </button>
      </div>
      <TransfertList 
        labelMuestra='Productos Disponibles'
        labelSelected='Productos Seleccionados'
        dataShow={productos}
        dataSelect={productosSeleccionados}
        onChange={onChange}
      />
      <ModalSave show={visible} toggleOverlay={() => setVisible(!visible)} handleAccept={handleSave}/>
    </div>
  )
})

const ModalSave = ({show, toggleOverlay, handleAccept}) => {

  const methods = useForm({
    defaultValues: {
      fecha: getFechaToCalendarRange(),
    }
  })

  const { control, formState: { errors }, handleSubmit} = methods;

  const onSubmit = (data) => {
    handleAccept(data)
    toggleOverlay()
  }

  const onError = (error) => {}
  return (
    <div>
      <FormProvider {...methods} className="w-100">
          <Modal
              id={`modalId`}
              size={'sm'}
              show={show}
              onHide={toggleOverlay}
              backdrop="static"
              className="modalCRUD p-0 m-0"
              centered
          >
              <Modal.Header className="headerModal" closeButton>
                  <a className="icon-container">
                      <div />
                      <i className="fas fa-calendar" />
                  </a>
                  <Modal.Title className="mb-0">
                      Agregar productos
                  </Modal.Title>
              </Modal.Header>
              <Modal.Body className="p-4">
                <div>
                  <p className="mw-100 text-justify h6 font-weight-bold">Selecciona la vigencia de los productos.</p>
                </div>
                
                <CalendarFormRange 
                  inputProps={{ control }} 
                  identificador="fecha" 
                  label="Fecha Inicio - Fecha Fin"
                  required={true} 
                  className={`${classResponsiveFormDoubleWidthHeader} mt-3`} 
                  rules={{ pattern: { value: /\S+@\S+\.\S+/ } }}
                  customError={errors.fecha ? ERROREMAILFIELDREQUIRED : null} 
                />

                <div className="d-flex justify-content-end align-items-center"> 
                    <Button className="mx-1" style={{outline: 'none'}} onClick={handleSubmit(onSubmit, onError)}>Aceptar</Button>
                    <Button className="mx-1" style={{outline: 'none'}} onClick={toggleOverlay}>Cancelar</Button>
                </div>
                </Modal.Body>
          </Modal>
        </FormProvider>
    </div>
  )
}

const FormCRUDProductoMercado = ({properties}) => {
  const { productosMercado, productos, mercado, producto } = properties
  const tableRef = useRef(null);
  const dispatch = useDispatch();
  const editRef = useRef(false);
  const [rowData, setRowData] = useState(productosMercado)
  const [productosDisponibles, setProductosDisponibles] = useState(productos)
  const [productosSeleccionados, setProductosSeleccionados] = useState([])

  useEffect(() => {
    Emitter.on('EDIT', ({params, type}) => handleAction({params, type}))
    Emitter.on('SAVE', ({params, type}) => handleAction({params, type}))
    Emitter.on('CANCEL', ({params, type}) => handleAction({params, type}))
    return () => {
      Emitter.off('EDIT')
      Emitter.off('SAVE')
      Emitter.off('CANCEL')
    }
  }, [rowData])

  const handleAction = async ({params, type}) => {
    let dataRow = params.data;

    switch (type) {
      case 'EDIT':
        if(editRef.current){
          dispatch({type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning, message: 'Solo puedes editar un registro a la vez' } } )
          return;
        }
        editRef.current = true;
        dataRow.edit = true;
        tableRef.current.api.setFocusedCell(params.rowIndex, 'dtVigenciaIni')
          tableRef.current.api.startEditingCell({
            rowIndex: params.rowIndex,
            colKey: 'dtVigenciaIni',
            key: 'Backspace',
          });
        params.api.applyTransaction({ update: [dataRow] });
        params.api.refreshCells({force: true});
        break;
      case 'SAVE':
        try {
          const { status, msg } = await mercadoServices.updateProductoMercado({
            mercado: mercado,
            producto: dataRow.nbProducto,
            fechaFin: dataRow.dtVigenciaFin,
            fechaInicio: dataRow.dtVigenciaIni
          });

          if(status){
            editRef.current = false;
            // dataRow.edit = false;
            // params.api.applyTransaction({ update: [dataRow] });
            // params.api.refreshCells({force: true});
            getData();
            dispatch({type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: msg } } )
          }
        } catch (error) {
          dispatch({type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } } )
        }
        break;
      case 'CANCEL':
        editRef.current = false;
        dataRow.edit = false;
        params.api.applyTransaction({ update: [dataRow] });
        params.api.refreshCells({force: true});
        break;

      default:
        break;
    }
  }

  const handleAddProducto = async (data) => {
    try {
      const { status, msg } = await mercadoServices.setProductosMercado({
        mercado: mercado,
        productos: productosSeleccionados,
        fechaInicio: dateToStringFormat(data.fecha[0]),
        fechaFin: dateToStringFormat(data.fecha[1]),
      });

      if(status){
        getData()
        dispatch({type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: msg } } )
      }
    } catch (error) {
      dispatch({type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } } )
    }
  }

  const getData = async () => {
    try {
      const { status, data, msg } = await mercadoServices.getProductsByMercado({
        mercado: mercado,
        producto: producto,
      })

      if(status){
        setRowData(data.productosMercado)
        setProductosDisponibles(data.productos)
        setProductosSeleccionados([]) 
      }
    } catch (error) {
      dispatch({type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } } )
    }
  }

  const handleChange = (data) => {
    setProductosSeleccionados(data.dataSelectedTemp)
  }

  return (
    <> 
      <Tabs 
        tabs={[
          {show: true, text: "Productos", value: "productos", icon: "fas fa-shopping-basket",
            component: <Products tableRef={tableRef} rowData={rowData} producto={producto}/>},
          {show: true, text: "Agregar Productos", value: "addProductos", icon: "fas fa-plus",
            component: <AddProducts productos={productosDisponibles} productosSeleccionados={productosSeleccionados} handleSave={handleAddProducto} onChange={handleChange}/>},
        ]}
        defaultValue="productos"
      />
    </>
  )
}

export default FormCRUDProductoMercado